import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { StepFinish } from './finish';
import { StepConfirm } from './confirm';
import { StepStart } from './start';
import { StepOne } from './one';
import { StepTwo } from './two';
import { StepThree } from './three';
import { StepFour } from './four';
import { Summary } from './summary';

// https://react.semantic-ui.com/
import '../../_utilities/semantic-css';
import { IForm, IFormValidation } from './types';
import { StepError } from './error';
import { Info } from './info';

export const isValidForm = (form) => {
    if (form) {
        const errorElements = form.querySelectorAll('.is--error');
        let errors = false;
        if (errorElements.length > 0) errors = true;

        const inputs = form.querySelectorAll('input');
        let empty = false;
        inputs.forEach((el) => {
            if (el.hasAttribute('data-required') && el.value.length == 0) {
                empty = true;
            }
        })
        if (!errors && !empty) return true;
    }
    return false;
}

export const updateDataToObj = (obj, path, value, index = -1, extraKey = '') => {
    let tempObj = obj;
    const keysPath = path.split('.');
    switch (keysPath.length) {
        case 1:
            if (index >= 0) {
                if (extraKey != '') {
                    tempObj[keysPath[0]][index][extraKey] = value;
                } else {
                    tempObj[keysPath[0]][index] = value;
                }
            } else {
                tempObj[keysPath[0]] = value
            }
            break;
        case 2:
            if (index >= 0) {
                if (extraKey != '') {
                    tempObj[keysPath[0]][keysPath[1]][index][extraKey] = value;
                } else {
                    tempObj[keysPath[0]][keysPath[1]][index] = value;
                }
            } else {
                tempObj[keysPath[0]][keysPath[1]] = value
            }
            break;
        case 3:
            if (index >= 0) {
                if (extraKey != '') {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][index][extraKey] = value;
                } else {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][index] = value;
                }
            } else {
                tempObj[keysPath[0]][keysPath[1]][keysPath[2]] = value
            }
            break;
        case 4:
            if (index >= 0) {
                if (extraKey != '') {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]][index][extraKey] = value;
                } else {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]][index] = value;
                }
            } else {
                tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]] = value
            }
            break;
        case 5:
            if (index >= 0) {
                if (extraKey != '') {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]][keysPath[4]][index][extraKey] = value;
                } else {
                    tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]][keysPath[4]][index] = value;
                }
            } else {
                tempObj[keysPath[0]][keysPath[1]][keysPath[2]][keysPath[3]][keysPath[4]] = value
            }
            break;
    }
    return tempObj;
};

export const getTextFromObject = (array, value)=>{
    let output = '';
    array.forEach(element => {
        if (element.value == value) output = element.text;
    });
    return output
};

export const API_HOST = '/b2bhub';

export const receiverTypeOptions = [
    { key: 'a', text: 'Jednostka budżetowa/samorządowa/Spółka Skarbu Państwa', value: 10 },
    { key: 'b', text: 'Jednoosobowa działalność gospodarcza', value: 20 },
    { key: 'c', text: 'Spółka cywilna/z o.o./akcyjna/itp', value: 30 },
    { key: 'd', text: 'Organizacja Społeczna/ Fundacja/Stowarzyszenie', value: 40 },
]

export const invoicingFrequencyOptions = [
    { key: 'a', text: 'Codziennie', value: 10 },
    { key: 'b', text: '4 razy w miesiącu (1-szego, 9-tego, 16-tego, 23-ego lub następnego dnia roboczego)', value: 20 },
]


export const Form = () => {


    const wrapper = document.getElementById("form-app");
    const root = createRoot(wrapper);
    root.render(<FormApp />);

    function FormApp() {

        const params = (new URL(document.location)).searchParams;

        const stepIndex = params.get('confirmed') ? 200 : 1;
        if (stepIndex == 200) {
            fetch(API_HOST+'/contractor/confirm/' + params.get('token'))
                .then((res) => {
                    if (res.status !== 400) {
                        setStepInd(200);
                    }
                })
        }

        const [stepInd, setStepInd] = useState(stepIndex);
        const [outputData, setOutputData] = useState<IForm>({
            "receiver": {
                "receiverType": 10,
                "receiverName": '',
                "receiverNIP": '',
                "receiverAddress": {
                    "street": '',
                    "houseNo": '',
                    "flatNo": '',
                    "zipCode": '',
                    "city": '',
                    "country": 'PL'
                },
                "receiverRegisterPeriod": true,
                "receiverRegisterVat": true,
                "receiverRepresentatives": [
                    {
                        "representativeName": '',
                        "representativeSurname": '',
                        "representativeID": '',
                        "representativePesel": '',
                        "representativePhone": ''
                    }
                ]
            },
            "buyer": {
                "sameAsReceiver": true,
                "buyerCompanyName": '',
                "buyerNIP": '',
                "buyerPayerName": '',
                "buyerPayerAddress": '',
                "buyerAddress": {
                    "street": '',
                    "houseNo": '',
                    "flatNo": '',
                    "zipCode": '',
                    "city": '',
                    "country": 'PL'
                }
            },
            "applicant": {
                "applicantName": '',
                "applicantPosition": '',
                "applicantPhone": '',
                "applicantEmail": ''
            },
            "billingData": {
                "billingEmails": [''],
                "bankAccounts": [
                    {
                        "bankName": '',
                        "bankAccountNumber": ''
                    }
                ]
            },
            "contactDetails": [
                {
                    "contactName": '',
                    "contactPhone": '',
                    "contactEmail": ''
                }
            ],
            "contractConditions": {
                "totalLimit": '',
                "cardsNumber": '',
                "invoicingFrequency": 10,
                "paymentDelay": 15,
                "contractCards": [
                    {
                        "cardNo": 1,
                        "cardLimit": '',
                        "cardPhoneNumber": ""
                    }
                ]
            },
            "clientIPAddress": "192.168.0.1",
            "additionalNotes": "",
        })
        const [validationData, setValidationData] = useState<IFormValidation>({
            "receiver": {
                "receiverType": undefined,
                "receiverName": undefined,
                "receiverNIP": undefined,
                "receiverAddress": {
                    "street": undefined,
                    "houseNo": undefined,
                    // "flatNo": undefined,
                    "zipCode": undefined,
                    "city": undefined
                },
                "receiverRegisterPeriod": undefined,
                "receiverRegisterVat": undefined,
                "receiverRepresentatives": [
                    {
                        "representativeName": undefined,
                        "representativeSurname": undefined,
                        "representativeID": undefined,
                        "representativePesel": undefined,
                        "representativePhone": undefined
                    }
                ]
            },
            "buyer": {
                "buyerCompanyName": undefined,
                "buyerNIP": undefined,
                "buyerAddress": {
                    "street": undefined,
                    "houseNo": undefined,
                    // "flatNo": undefined,
                    "zipCode": undefined,
                    "city": undefined
                }
            },
            "applicant": {
                "applicantName": undefined,
                "applicantPosition": undefined,
                "applicantPhone": undefined,
                "applicantEmail": undefined
            },
            "billingData": {
                "billingEmails": [undefined],
                "bankAccounts": [
                    {
                        "bankName": undefined,
                        "bankAccountNumber": undefined
                    }
                ]
            },
            "contactDetails": [
                {
                    "contactName": undefined,
                    "contactPhone": undefined,
                    "contactEmail": undefined
                }
            ],
            "contractConditions": {
                "totalLimit": undefined,
                "cardsNumber": undefined,
                "invoicingFrequency": undefined,
                "paymentDelay": undefined,
                "contractCards": [
                    {
                        "cardNo": undefined,
                        "cardLimit": undefined,
                        "cardPhoneNumber": undefined
                    }
                ]
            }
        })

        useEffect(() => {
            setTimeout(()=>{
                window.scrollTo(0, 0);
            }, 100)
        }, [stepInd]);

        return <div className="m-form__app">

            { params.get('develop') && <Info /> }

            {stepInd > 0 && stepInd < 100 && <ol className="m-form__pagination">
                <li className={`${stepInd >= 1 ? 'is--active' : ''} ${stepInd > 1 ? 'is--old' : ''}`}><span>Dane Wnioskującego</span></li>
                <li className={`${stepInd >= 2 ? 'is--active' : ''} ${stepInd > 2 ? 'is--old' : ''}`}><span>Dane do rozliczeń i kontaktu</span></li>
                <li className={`${stepInd >= 3 ? 'is--active' : ''} ${stepInd > 3 ? 'is--old' : ''}`}><span>Wnioskowane Warunki Umowy</span></li>
                <li className={`${stepInd >= 4 ? 'is--active' : ''} ${stepInd > 4 ? 'is--old' : ''}`}><span>Konfiguracja Kart</span></li>
                <li className={`${stepInd >= 10 ? 'is--active' : ''} ${stepInd > 10 ? 'is--old' : ''}`}><span>Podsumowanie</span></li>
            </ol>}

            {stepInd == 0 && <StepStart nextStep={setStepInd} />}
            {stepInd == 1 && <StepOne inputData={outputData} saveData={setOutputData} validationData={validationData} saveValidationData={setValidationData} nextStep={setStepInd} />}
            {stepInd == 2 && <StepTwo inputData={outputData} saveData={setOutputData} validationData={validationData} saveValidationData={setValidationData} nextStep={setStepInd} />}
            {stepInd == 3 && <StepThree inputData={outputData} saveData={setOutputData} validationData={validationData} saveValidationData={setValidationData} nextStep={setStepInd} />}
            {stepInd == 4 && <StepFour inputData={outputData} saveData={setOutputData} validationData={validationData} saveValidationData={setValidationData} nextStep={setStepInd} />}
            {stepInd == 10 && <Summary inputData={outputData} nextStep={setStepInd} />}
            {stepInd == 100 && <StepFinish email={outputData.applicant.applicantEmail } />}
            {stepInd == 200 && <StepConfirm />}
            {stepInd == 400 && <StepError />}

        </div>
    }

}

